export default __webpack_public_path__ + "static/hipopener_3-fe5e4dc765f2f6c6110e676af12cf637.jpg";